import React from 'react';

interface TifpaLogoProps {
  className?: string;
}

const TifpaLogo: React.FC<TifpaLogoProps> = ({ className = '' }) => {
  // Check if we have a height class to determine if we should use compact sizing
  const isCompact = className.includes('h-6');

  return (
    <div
      className={`flex flex-col items-center w-full justify-center ${className}`}
    >
      <div
        className={`w-full flex flex-row items-center justify-center gap-1 ${
          isCompact ? 'max-w-12' : 'max-w-24'
        }`}
      >
        <p
          className={`font-serif font-bold text-tifpa-rose line-height-1 ${
            isCompact ? 'text-xl' : 'text-4xl'
          }`}
        >
          TIFPA
        </p>
      </div>
      <p
        className={`text-stone-500 font-body font-bold text-center w-full -mt-2 ${
          isCompact ? 'text-4xs max-w-12' : 'text-3xs max-w-24'
        }`}
      >
        &nbsp;CONSULTING,LLC
      </p>
    </div>
  );
};

export default TifpaLogo;
